import type { VariableCost, CalculatorResult } from '../types'
import { formatCurrency } from './formatters'

export interface CPAMaximoInputs {
  precoProduto: number
  taxaPlataformaPercent: number
  taxaPlataformaFixo: number
  custosVariaveis: VariableCost[]
  metaVendas: number
}

export function calcularCPAMaximo(inputs: CPAMaximoInputs): CalculatorResult[] {
  const { precoProduto, taxaPlataformaPercent, taxaPlataformaFixo, custosVariaveis, metaVendas } = inputs

  const taxaPlataforma = precoProduto * (taxaPlataformaPercent / 100) + taxaPlataformaFixo

  let custosVariaveisTotal = 0
  for (const custo of custosVariaveis) {
    if (custo.type === 'percentage') {
      custosVariaveisTotal += precoProduto * (custo.value / 100)
    } else {
      custosVariaveisTotal += custo.value
    }
  }

  const custosTotais = taxaPlataforma + custosVariaveisTotal
  const margem = precoProduto - custosTotais
  const cpaDisponivel = Math.max(margem, 0)

  const cpa1x = cpaDisponivel
  const cpa15x = cpaDisponivel / 1.5
  const cpa2x = cpaDisponivel / 2

  const budget1x = metaVendas * cpa1x
  const budget15x = metaVendas * cpa15x
  const budget2x = metaVendas * cpa2x

  const faturamento = metaVendas * precoProduto

  return [
    { label: 'Faturamento', value: faturamento, formattedValue: formatCurrency(faturamento), status: faturamento > 0 ? 'accent' : undefined },
    { label: 'Custos Totais', value: custosTotais, formattedValue: formatCurrency(custosTotais) },
    { label: 'Margem de Contribuição', value: margem, formattedValue: formatCurrency(margem), status: margem > 0 ? 'success' : 'danger' },
    { label: 'CPA Break-even (1x)', value: cpa1x, formattedValue: margem > 0 ? formatCurrency(cpa1x) : 'Inviável', status: 'danger' },
    { label: 'CPA 1.5x ROI', value: cpa15x, formattedValue: margem > 0 ? formatCurrency(cpa15x) : 'Inviável', status: margem > 0 ? 'warning' : 'danger' },
    { label: 'CPA 2x ROI', value: cpa2x, formattedValue: margem > 0 ? formatCurrency(cpa2x) : 'Inviável', status: margem > 0 ? 'success' : 'danger' },
    { label: 'Budget Break-even', value: budget1x, formattedValue: margem > 0 ? formatCurrency(budget1x) : 'Inviável', status: 'danger' },
    { label: 'Budget 1.5x ROI', value: budget15x, formattedValue: margem > 0 ? formatCurrency(budget15x) : 'Inviável', status: margem > 0 ? 'warning' : 'danger' },
    { label: 'Budget 2x ROI', value: budget2x, formattedValue: margem > 0 ? formatCurrency(budget2x) : 'Inviável', status: margem > 0 ? 'success' : 'danger' },
  ]
}
